import { COLORS } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled, { css } from 'styled-components';

interface StyledProps {
  zIndex: number;
  borderRadius: number;
  singleImage: boolean;
}

export const ContainerRelative = styled.div`
  position: relative;
  border: 1px solid ${COLORS.BORDER};
  border-radius: 20rem;
  width: 152rem;
  height: 110rem !important;
  overflow: hidden;
  ${(props: StyledProps) =>
    props.singleImage
      ? css`
          width: 58rem;
        `
      : css`
          width: 152rem;
        `};

  ${respondTo.smallLaptop`
    width: 25%;
    height: 80rem !important;
    overflow: hidden;
  `}
`;

export const SmallFormImageLayerImage = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  user-select: none;
  cursor: pointer;

  ${(props: StyledProps) =>
    props.zIndex &&
    css`
      z-index: ${props.zIndex};
    `};
  ${(props: StyledProps) =>
    props.borderRadius &&
    css`
      border-radius: ${props.borderRadius};
    `};
  ${(props: StyledProps) =>
    props.singleImage
      ? css`
          width: 58rem;
        `
      : css`
          max-width: 152rem;
          width: 100%;
        `};

  ${respondTo.midTablet`
    width: 100%;
  `}
`;
